import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class VariablesService {
    private currentTheme: string = 'default-theme';
    private imgSystem = {tipo: '', base64: ''};
    private userNameSubject = new BehaviorSubject<string>(localStorage.getItem('token') != null ? localStorage.getItem('userName') : '');
    userName$ = this.userNameSubject.asObservable();
  
    getCurrentTheme(): string {
      return this.currentTheme;
    }
  
    setUserName(name: string): void {
    this.userNameSubject.next(name);
    }

    setImgSystem(tipo, base64): void {
      this.imgSystem.tipo = tipo
      this.imgSystem.base64 = base64
    }

    getImgSystem() {
      return this.imgSystem;
    }
  }